import { Deserializable } from './deserializable.model';
import { User } from './user.model';
import { TableConfig } from './table-config.interface';

export interface NotificationContact {
  emailAddress: string;
  isEnabled: boolean;
}

export interface NotificationSettings {
  isEnabled: boolean;
  contacts: NotificationContact[];
}

export class UserSettings implements Deserializable<UserSettings> {
  _id: string;
  user: string | User;
  notifications?: {
    _id: string;
    EMAIL: NotificationSettings,
  };
  isDarkTheme: boolean = false;
  tableConfigs?: TableConfig;
  favoriteTemplates?: string[];
  homeWarrantyPopup: { optedOut: boolean, lastShown: Date | null } = { optedOut: false, lastShown: null };

  get userId(): string {
    if (!this.user) { return null; }
    if (this.user instanceof User) {
      return this.user._id;
    }
    return this.user;
  }

  constructor(value?: Partial<UserSettings>) {
    this.deserialize(value);
  }

  deserialize(value: Partial<UserSettings>) {
    Object.assign(this, value || {});

    if (value?.homeWarrantyPopup?.lastShown) {
      this.homeWarrantyPopup.lastShown = new Date(this.homeWarrantyPopup.lastShown);
    }

    return this;
  }
}
